/** Installer price tiers (Trade / Approved / … + any staff add) from GET /api/installer-tiers. */
import { useCallback, useEffect, useState } from 'react';
import API_URL from '@/config/api';

export const DEFAULT_TIERS = [
  { slug: 'trade', label: 'Trade', order: 0, discount_pct: null, built_in: true },
  { slug: 'approved', label: 'Approved', order: 1, discount_pct: null, built_in: true },
  { slug: 'elite_approved', label: 'Elite Approved', order: 2, discount_pct: null, built_in: true },
];

export default function useInstallerTiers() {
  const [tiers, setTiers] = useState(DEFAULT_TIERS);
  const [loaded, setLoaded] = useState(false);
  const reload = useCallback(async () => {
    try {
      const r = await fetch(`${API_URL}/api/installer-tiers`, { credentials: 'include' });
      if (r.ok) setTiers(await r.json());
    } catch { /* keep defaults */ } finally { setLoaded(true); }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const labels = Object.fromEntries(tiers.map((t) => [t.slug, t.label]));
  return { tiers, labels, loaded, reload, setTiers };
}
